import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MethodsHelper } from "@app/helpers/methods.helper";

@Component({
    selector: "app-import-result-popup",
    templateUrl: "./import-result-popup.component.html",
    styleUrls: ["./import-result-popup.component.css"],
    standalone: false
})
export class ImportResultPopupComponent implements OnInit {
  @Input() displayDialog: boolean;
  @Input() title: string;
  @Input() result: any;
  @Input() isSuccess: any;
  @Output() onClose = new EventEmitter();

  constructor() {}

  ngOnInit() {
  }

  onDownload() {
    if (this.result) {
      let name = MethodsHelper.getFileName(this.result);
      MethodsHelper.downLoadFile(this.result.body,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        name
      );
    }
  }

  onClosePopup() {
    if (this.onClose) {
      this.onClose.emit(this.isSuccess);
    }
  }
}
